import React, { useState, useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import styles from './HolidayModal.module.scss';
import CloseWhite from '../../../src/assets/icons/closeWhite.svg';
import CloseBlack from '../../../src/assets/icons/closeBlack.svg';
import { isMobile } from '../../../src/utils/mobileOptimizer';

export default function HolidayModal({ fields }) {
  const _isMobile = isMobile();
  const [isVisible, setIsVisible] = useState(false);
  // 禁用页面滚动
  const disableBodyScroll = () => {
    document.body.classList.add(styles.bodyNoScroll);
  };
  // 恢复页面滚动
  const enableBodyScroll = () => {
    document.body.classList.remove(styles.bodyNoScroll);
  };
  const showTime = fields.showTime.value; // (2025-11-18T16:00:00Z)
  const desktopImageValue =
    fields.desktopImage && fields.desktopImage.value ? fields.desktopImage.value : '';
  const mobileImageValue =
    fields.mobileImage && fields.mobileImage.value ? fields.mobileImage.value : '';
  // 时间比较逻辑
  const shouldShowModal = () => {
    if (!showTime) return false;
    try {
      const showDateTime = new Date(showTime);
      const currentDateTime = new Date();
      return showDateTime > currentDateTime;
    } catch (error) {
      console.error('Error parsing showTime:', error);
      return false;
    }
  };
  // onClose事件处理
  const onClose = () => {
    setIsVisible(false);
    // enableBodyScroll(); // 关闭时恢复滚动
  };
  // 组件挂载时检查是否应该显示
  useEffect(() => {
    const showModal = shouldShowModal();
    setIsVisible(showModal);
    if (showModal) {
      // disableBodyScroll(); // 显示时禁用滚动
    }
  }, [showTime]);
  // 如果没有显示时间字段或不应该显示，则不渲染任何内容
  if (!isVisible) {
    return null;
  }
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={_isMobile ? `${styles.content} ${styles.mobile}` : styles.content}>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            <img src={_isMobile ? CloseWhite : CloseBlack} alt={'x'} />
          </button>
          <div className={styles.flexBox}>
            <div className={styles.imageBox}>
              {!_isMobile && desktopImageValue && desktopImageValue.src && (
                <img
                  src={desktopImageValue.src}
                  alt={desktopImageValue.alt || '节日图片'}
                  width="388"
                  height="450"
                />
              )}
              {_isMobile && mobileImageValue && mobileImageValue.src && (
                <img
                  src={mobileImageValue.src}
                  alt={mobileImageValue.alt || '节日图片'}
                  width="327"
                  height="270"
                />
              )}
            </div>
            <div className={styles.textBox}>
              <div className={styles.textTitle}>{fields?.title?.value}</div>
              <div className={styles.textDescription}>{fields?.description?.value}</div>
              <a
                href={`${fields?.url?.value?.href || ''}${fields?.url?.value?.querystring || ''}`}
                className={styles.textBtn}
              >
                {fields?.url?.value?.text}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
